module.exports = __webpack_public_path__ + "03_hair_black.792e5ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/03_hair_black.png
// module id = IMyR
// module chunks = 0